import {Radio, cn} from '@heroui/react';
export default function CustomRadio(props) {
	const {children, ...otherProps} = props;

	return (
		<Radio
			{...otherProps}
			classNames={{
				base: cn('inline-flex m-0 items-center justify-between', 'flex-row-reverse max-w-[500px] cursor-pointer rounded-lg gap-4 p-4 border-2 border-transparent', 'border-secondaryBackground data-[selected=true]:border-primary'),
			}}>
			{children}
		</Radio>
	);
}
